import { isWindowClassType } from './lessonHelpers'

const isEmpty = (value) => value === undefined || value === null || value === ''

export function validateEditScheduleForm(form, { isCreating = false } = {}) {
    const issues = []

    const requireField = (value, label) => {
        if (isEmpty(value)) {
            issues.push({ label })
        }
    }

    requireField(form.bell_id, 'Номер пары')
    requireField(form.class_date, 'Дата')
    requireField(form.subject_id, 'Предмет')
    requireField(form.teacher_id, 'Преподаватель')
    requireField(form.building_id, 'Корпус')
    requireField(form.room_id, 'Кабинет')

    const groupIds = Array.isArray(form.group_id) ? form.group_id : []
    if (groupIds.length === 0) {
        issues.push({ label: isCreating ? 'Группы' : 'Группа' })
    }

    if (isEmpty(form.class_type_id)) {
        issues.push({ label: 'Тип занятия' })
    } else if (isWindowClassType(form.class_type_id)) {
        issues.push({
            label: 'Тип занятия',
            hint: 'выберите тип, отличный от «Окно»',
        })
    }

    return issues
}
